import React from 'react';
import { render } from '@testing-library/react';
import { Divider } from './Divider';
import { Icon } from '../Icon';

describe('Divider', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Divider
				spacing="1"
				vertical={false}
				data-auto-sel="automation-selector"
			>
				<Icon name="help" key={1} size="24" />
			</Divider>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
